import { Pipe, PipeTransform } from '@angular/core';

import { AnalyticEventEvaluatorUtil } from '../utils/analytic-event-evaluator.util';

@Pipe({
	name: 'analyticEventEvaluatorPipe'
})
/**
 * Gets mode for the user's journey, either Self Service || Portfolio Solution, and pre-appends it to the analytic event
 */
export class AnalyticEventEvaluatorPipe implements PipeTransform {
	public transform(analyticsEvent: string): any {
		return AnalyticEventEvaluatorUtil.transform(analyticsEvent);
	}
}
